import type { TransferStatus } from './PortfolioPosition';

export type PortfolioTimelineEntryType = 'position_created' | 'position_updated' | 'listed' | 'listing_updated' | 'sale_recorded' | 'sale_updated' | 'sale_deleted' | 'transfer_not_sent' | 'transfer_waiting' | 'transfer_accepted' | 'transfer_pdf_delivered' | 'transfer_physical_delivery' | 'transfer_cancelled' | 'position_cancelled';

/** A local activity record based solely on a saved portfolio action. */
export interface PortfolioTimelineEntry {
  id: string;
  positionId: string;
  type: PortfolioTimelineEntryType;
  timestamp: string;
  label: string;
  description?: string;
  relatedSaleId?: string;
  note?: string;
  metadata?: { marketplace?: string; quantity?: number; transferStatus?: TransferStatus };
  createdAt: string;
}

export const timelineLabel: Record<PortfolioTimelineEntryType, string> = {
  position_created: 'Pozice vytvořena', position_updated: 'Pozice upravena', listed: 'Pozice zalistována', listing_updated: 'Inzerát upraven',
  sale_recorded: 'Zaznamenán prodej', sale_updated: 'Prodej upraven', sale_deleted: 'Prodej odstraněn', transfer_not_sent: 'Transfer odeslán',
  transfer_waiting: 'Čeká na přijetí', transfer_accepted: 'Transfer přijat', transfer_pdf_delivered: 'PDF / e-ticket doručen',
  transfer_physical_delivery: 'Osobní předání', transfer_cancelled: 'Transfer zrušen', position_cancelled: 'Pozice zrušena',
};

export const transferTimelineType: Record<TransferStatus, PortfolioTimelineEntryType> = {
  not_sent: 'transfer_not_sent', waiting_for_acceptance: 'transfer_waiting', accepted: 'transfer_accepted', pdf_delivered: 'transfer_pdf_delivered', physical_delivery: 'transfer_physical_delivery', cancelled: 'transfer_cancelled',
};
